<template>
  <div class="created">
    <!-- 新增/编辑 -->
    <el-dialog :title="List ? '编辑SKU' : '新建SKU'" :visible.sync="dialogVisible" width="70%" top="4vh" :before-close="beforeClose">
      <el-form ref="form" :rules="rules" :model="form" label-width="150px">
        <el-row type="flex" align="middle" v-show="show">
          <el-form-item>
            <el-row type="flex" align="middle" slot="label">
              <p>请选择销售类型</p>
              <el-tooltip placement="top">
                <div slot="content">
                  普通销售：即单一变体的销售<br />
                  捆绑销售：A产品和B产品组合成新的产品销售<br />
                  组合销售：A产品可以选择性和B产品或者C产品进行组装销售<br />
                  变参销售：带颜色多种变体的销售
                </div>
                <i class="el-icon-question" />
              </el-tooltip>
              <p>：</p>
            </el-row>
            <el-radio-group v-model="form.salesType" @change="handleRadio">
              <el-radio label="1">普通销售</el-radio>
              <el-radio label="2">变参销售</el-radio>
              <el-radio label="3">捆绑销售</el-radio>
              <!-- <el-radio label="4">组合销售</el-radio> -->
            </el-radio-group>
          </el-form-item>
        </el-row>
        <el-row type="flex" align="middle">
          <el-button type="primary" v-if="form.salesType == '3' || form.salesType == '4'" style="margin-bottom:20px"
            @click="handleAssociated">关联现有产品</el-button>
          <div class="summary_complete_bag" v-if="form.salesType == '2'">
            <div class="summary_complete">
              <div style="border-radius: 4px 0 0 4px;" @click="complete(1)" v-bind:class="{ active: type === 1 }">
                基本信息
              </div>
              <div style="border-radius: 0 4px 4px; 0" @click="complete(2)" v-bind:class="{ active: type === 2 }">
                变体信息
              </div>
            </div>
          </div>
        </el-row>
        <el-table v-if="form.salesType == '3' || form.salesType == '4'" border :data="productData"
          style="width: 100%;margin-bottom:20px">
          <el-table-column label="商品图片" align="center">
            <template slot-scope="scope">
              <el-image v-if="scope.row.productSkuImages" style="width: 100px; height: 100px"
                :src="scope.row.productSkuImages[0]" fit="fill" :preview-src-list="scope.row.productSkuImages">
              </el-image>
              <el-image v-else style="width: 100px; height: 100px"
                :src="scope.row.productImages ? scope.row.productImages[0] : ''" fit="fill" :preview-src-list="scope.row.productImages ? scope.row.productImages : []">
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="productCode" label="商品SKU" align="center">
            <template slot-scope="scope">
              <div>
                <p>{{ scope.row.productCode ? scope.row.skuPrex+'-'+scope.row.productCode : scope.row.variantSku }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="数量" align="center">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.stockNum" placeholder="" style="width:120px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <div>
                <el-button type="text" style="border:none" @click="delData(scope.row, scope.$index)">删除</el-button>
              </div>
              <!-- <div>
                <el-button type="text" style="border:none">历史采购</el-button>
              </div> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="Minister-top-top productbackground" v-if="type != 2">
          <div class="Minister-top-left product-top-color">商品图片</div>
        </div>
        <el-form-item label="商品图片：" v-if="type != 2">
          <div class="uploadPictures">
            <draggable
              class="list-group"
              tag="ul"
              @start="isDragging = true"
              @end="isDragging = false"
              :list="imgListSelect"
              handle=".list-group-item"
            >
              <li
                class="list-group-item"
                v-for="(element, index) in imgListSelect"
                :key="element.url+index"
              >
                <div class="mask">
                  <i
                    class="custom-icon el-icon-zoom-in"
                    @click="handlePictureCardPreview(element)"
                  ></i>
                  <i
                    class="custom-icon el-icon-delete"
                    @click="handleRemoveSelect(index)"
                  ></i>
                </div>
                <div class="badge">
                  <img :src="element.url" alt />
                </div>
              </li>
              <li
                @click="showImgDialog"
                class="avatar-uploader"
                slot="footer"
              >
                <i data-v-c660ac10 class="el-icon-plus"></i>
              </li>
            </draggable>
          </div>
          
          <!-- <el-upload :action="action" list-type="picture-card" :file-list="imgList" :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :headers="customHeaders" multiple>
            <i class="el-icon-plus" style="color: #0724ef;"></i>
          </el-upload> -->
        </el-form-item>
        <div class="Minister-top-top informationbackground" v-if="type != 2">
          <div class="Minister-top-left information-top-color">基本信息</div>
        </div>
        <el-form-item label="商品名称：" v-if="type != 2" prop="goodsName">
          <el-input v-model.trim="form.goodsName"></el-input>
        </el-form-item>
        <el-form-item label="中文简称：" v-if="type != 2" prop="chineseName">
          <el-input v-model.trim="form.chineseName"></el-input>
          <el-checkbox v-model="checked" style="margin-left:10px" @change="handleCheck">同商品名称</el-checkbox>
        </el-form-item>
        <el-form-item v-if="type != 2">
          <el-row type="flex" align="middle" justify="end" slot="label">
            <p>商品编号/SKU</p>
            <el-tooltip placement="top">
              <div slot="content">
                添加时方便分辨产品的属性样式等功能，非必填项
              </div>
              <i class="el-icon-question" />
            </el-tooltip>
            <p>：</p>
          </el-row>
          <el-input v-model.trim="form.productId">
            <template slot="prepend">
              <p v-if="prefix">{{ prefix }}</p>
            </template>
          </el-input>
          <el-button style="border:none" type="text" @click="dialogVisibleSKU = true">去设置</el-button>
        </el-form-item>
        <div v-for="(item, index) in aliasList" :key="index+'w'" class="morePlatform">
          <el-row type="flex" :gutter="20">
            <el-col :span="12" :offset="0">
              <el-form-item label="平台：" v-if="form.salesType == '1' || form.salesType == '3'" style="width:100%">
                <el-select v-model="item.sellerType" @change="changePlatform(index)" placeholder="请选择平台" clearable filterable>
                  <el-option v-for="item in platform" :key="item.sellerType" :label="item.itemTypeName"
                    :value="item.sellerType"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" :offset="0">
              <el-form-item label="店铺：" v-if="form.salesType == '1' || form.salesType == '3'" style="width:100%">
                <el-select v-model="item.shopName" filterable @change="shopChange(index)" placeholder="请选择店铺" clearable>
                  <el-option v-for="ele in item.ShopList" :key="ele.shopId" :label="ele.shopName" :value="ele.shopName">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="录入别名：" v-if="form.salesType == '1' || form.salesType == '3'">
              <el-row type="flex">
                <el-input v-model.trim="item.productCodeAlias" style="margin-right:10px;width:100%"
                  @change="verifyAlias($event, item.sellerType, item.shopId, 1, index)"></el-input>
                <div>
                  <el-button type="primary" icon="el-icon-plus" @click="edit_blue_point" :disabled="verifyDisabled"
                    v-if="index === 0"></el-button>
                  <el-button type="danger" @click="edit_blue_del(index)" icon="el-icon-close" v-else-if="index !== 0">
                  </el-button>
                </div>
              </el-row>
            </el-form-item>
          </el-row>
        </div>

        <div v-for="(item, index) in zuhealiasList" :key="index+'q'" class="morePlatform">
          <el-row type="flex" :gutter="20" v-if="form.salesType == '5'">
            <el-col :span="12" :offset="0">
              <el-form-item label="平台：" style="width:100%">
                <el-select v-model="item.sellerType" @change="changezuhePlatform(index)" placeholder="请选择平台" clearable filterable>
                  <el-option v-for="item in zuheplatform" :key="item.sellerType" :label="item.itemTypeName"
                    :value="item.sellerType"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" :offset="0">
              <el-form-item label="店铺：" style="width:100%">
                <el-select v-model="item.shopId" filterable @change="shopzuheChange(index)" placeholder="请选择店铺" clearable>
                  <el-option v-for="ele in item.ShopList" :key="ele.sellerId" :label="ele.shopName" :value="ele.sellerId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="form.salesType == '5'">
            <el-form-item label="选择别名：">
              <el-row type="flex">
                <!-- <el-input v-model="item.productCodeAlias" style="margin-right:10px;width:100%"
                  @blur="verifyAlias($event)"></el-input> -->
                <el-select v-model="item.productCodeAlias" filterable placeholder="请选择别名" style="margin-right:10px;width:100%" clearable>
                  <el-option v-for="(ele, ind) in item.aliasList" :key="ele.alias+ind" :label="ele.alias" :value="ele.alias">
                  </el-option>
                </el-select>
                <div>
                  <el-button type="primary" icon="el-icon-plus" @click="zuhezuhealiasList" 
                    v-if="index === 0"></el-button>
                  <el-button type="danger" @click="delzuhealiasList(index)" icon="el-icon-close" v-else-if="index !== 0">
                  </el-button>
                </div>
              </el-row>
            </el-form-item>
          </el-row>
        </div>

        <el-form-item label="选择分类：" v-if="type != 2" class="xingwarp">
          <span class="xingxing">*</span>
          <el-row type="flex" align="middle">
            <p v-if="classification" style="margin-right:10px">{{ classification.joinName }}</p>
            <el-button type="primary" size="mini" @click="selectClassification">选择分类</el-button>
          </el-row>
        </el-form-item>
        <el-form-item label="型号尺码：" v-if="form.salesType != '2'">
          <el-input v-model.trim="form.model"></el-input>
        </el-form-item>
        <el-form-item label="商品状态：" v-if="type != 2" prop="goodsState">
          <el-radio-group v-model="form.goodsState">
            <el-radio label="1">在售</el-radio>
            <el-radio label="2">停售</el-radio>
            <el-radio label="3">试卖</el-radio>
            <el-radio label="4">部分停售</el-radio>
            <el-radio label="5">清仓</el-radio>
            <el-radio label="6">部分清仓</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="货源URL：" v-if="type != 2">
          <el-row v-for="(item, index) in urlList" :key="index">
            <el-col :span="15">
              <el-input v-model.trim="item.value" style="width: 100%"></el-input>
            </el-col>
            <el-col :span="5" style="position: relative;margin-left: 10px;">
              <el-button type="primary" icon="el-icon-plus" @click="edit_blue_point1" v-if="index === 0"></el-button>
              <el-button type="danger" @click="edit_blue_del1(index)" icon="el-icon-close" v-else></el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="库存数量：" v-if="form.salesType == '1'">
          <el-input v-model.trim="form.inventory" disabled></el-input>
        </el-form-item>
        <el-row :gutter="20" v-if="form.salesType == '1' || form.salesType == '3'">
          <el-col :span="12" :offset="0">
            <el-form-item label="预估采购价格：">
              <el-input v-model.trim="form.estimatedPurchasePrice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <el-form-item label="预估运费：">
              <el-input v-model.trim="form.estimatedShipping"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="商品描述：" v-if="type != 2">
          <el-input type="textarea" v-model.trim="form.description"></el-input>
        </el-form-item>
        <el-form-item label="备注：" v-if="type != 2">
          <el-input type="textarea" v-model.trim="form.note"></el-input>
        </el-form-item>
      </el-form>
      <!-- <div v-if="type != 2 && form.salesType != '3' && form.salesType != '4'">
        <div class="Minister-top-top Ministerbackground">
          <div class="Minister-top-left Minister-top-color">SKU归属</div>
        </div>
        <el-button type="primary" @click="addAttributable">添加SKU归属者</el-button>
        <el-table :data="SKUAttributable" style="width: 100%;margin-top:20px" border>
          <el-table-column label="SKU归属者" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.roleId" :disabled="scope.row.disabled" placeholder="请选择角色">
                <el-option v-for="item in selectRidList" :key="item.rid"
                  :label="item.userName == null ? item.roleName : item.roleName + '-' + item.userName"
                  :value="item.rid"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="项目提成比例" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.percentageCommission" :disabled="scope.row.disabled" placeholder=""
                style="width:100%"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="请设置提成开始时间" align="center">
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.startTime" :disabled="scope.row.disabled"
                @change="startTime($event, scope.row)" align="right" type="datetime" placeholder="选择日期"
                style="width:100%" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column label="设置时间" prop="createTime" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" style="border:none" @click="
                deleteRow1(scope.row, scope.$index)
              ">删除</el-button>
              <div v-if="scope.row.id">
                <el-button type="text" style="border:none" v-if="scope.row.status === 1"
                  @click="handleBtn('disable', scope.row)">停用</el-button>
                <el-button type="text" style="border:none" v-else @click="handleBtn('enable', scope.row)">启用</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div> -->
      <div v-if="type == 2">
        <div style="margin-bottom:10px">
          <el-button plain @click="addVariant">添加变体信息</el-button>
          <el-button plain @click="OneOperation">批量修改状态</el-button>
        </div>
        <template v-for="(value, key, index) in selectVariants">
          <div style="margin-bottom:10px" :key="index" v-if="value.length">
            <el-button size="mini" @click="addSizeColor(value, key)">{{
                key
            }}</el-button>
            <el-tag size="small" closable style="height: 29px; margin-left: 10px; line-height: 28px"
              @close="delet(key)">{{ key }}
            </el-tag>
          </div>
        </template>
        <div class="summary_content">
          <div class="summary_list">
            <!-- 头部 -->
            <el-table :data="summarylist" style="width: 100%" element-loading-text="拼命加载中" border
              :header-cell-style="iscenter" @selection-change="on_batch_select" stripe max-height="600px">
              <el-table-column width="50" type="selection" align="center"></el-table-column>
              <el-table-column label="图片" width="200" align="center">
                <template slot-scope="scope">
                  <template v-if="scope.row.productSkuImages.length">
                    <ul class="checked-img-container" v-if="
                      scope.row.productSkuImages &&
                      scope.row.productSkuImages.length
                    ">
                      <li class="img-box" @click="Selected_pictures(scope.row,scope.$index)" v-for="(item, index) in scope.row.productSkuImages.slice(0,3)" :key="index">
                        <img style="width: 100%" :src="item.data" alt />
                        <i class="el-icon-circle-close" @click.stop="handleRemove1(scope.row,index)"></i>
                      </li>
                      <li class="img-box" v-show="
                        scope.row.productSkuImages.length > 3
                      ">
                        ...
                      </li>
                      <el-button type="mini" icon="el-icon-plus" @click="Select_pictures(scope.row, scope.$index)">
                      </el-button>
                    </ul>
                    <el-select v-model="Selected_pictures_value" placeholder="请选择"
                      v-show="scope.row.productSkuImages.length > 0" @change="Selected_picturesSame(Selected_pictures_value,scope.row)" style="width: 100%" clearable filterable>
                      <el-option key="all" label="所有变体" value="all_variant"></el-option>
                      <template v-if="isSyncInfoList">
                        <el-option v-for="(item, i) in specs" v-show="selectVariants[item.title].length" :key="i" :label="'相同' + item.title" :value="item.title">
                        </el-option>
                      </template>
                    </el-select>
                  </template>
                  <template v-else>
                    <el-button type="primary" @click="Select_pictures(scope.row, scope.$index)">选择图片</el-button>
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="productVariantMarker" label="变体标识" width="100">
              </el-table-column>
              <el-table-column prop="color" label="颜色" align="center" v-if="isShowColor"></el-table-column>
              <el-table-column prop="size" label="尺寸" align="center" v-if="isShowSize"></el-table-column>
              <el-table-column prop="sleeve" label="袖长" align="center" v-if="isShowSleeve">
              </el-table-column>
              <el-table-column prop="waist" label="腰长" align="center" v-if="isShowWaist">
              </el-table-column>
              <el-table-column label="SKU" width="320" align="center">
                <template slot-scope="scope">
                  <el-input v-model.trim="scope.row.variantCode" style="font-size: 12px;width:100%">
                    <template slot="prepend">
                      <p v-if="prefix">{{ prefix }} - {{ scope.row.productVariantMarker }}</p>
                    </template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column label="SKU别名" width="600" align="center">
                <template slot="header" slot-scope="scope">
                  <el-button type="primary" size="mini" @click="openDialog">同步</el-button>
                  SKU别名
                  <el-button type="primary" size="mini" @click="addDialog">补充</el-button>
                </template>
                <template slot-scope="scope">
                  <el-row type="flex" align="middle" v-for="(item, index) in scope.row.aliasDetailVO" :key="index"
                    style="margin-bottom:5px">
                    <el-select v-model="item.sellerType" @change="changeVariantPlatform(index, scope.$index)" placeholder="请选择平台" clearable filterable style="width: 220px">
                      <el-option v-for="item in platform" :key="item.sellerType" :label="item.itemTypeName"
                        :value="item.sellerType"></el-option>
                    </el-select>
                    <el-select v-model="item.shopName" @change="shopVariantChange(index, scope.$index)" :title="item.shopName" placeholder="请选择店铺" clearable filterable style="width: 440px">
                      <el-option v-for="ele in item.ShopList" :key="ele.shopId" :label="ele.shopName"
                        :value="ele.shopName"></el-option>
                    </el-select>
                    <el-input v-model="item.productCodeAlias" style="font-size: 12px;width:80%;margin-right:10px" :title="item.productCodeAlias"
                      maxlength="40" @change="verifyAlias($event, item.sellerType, item.shopId, 2, scope.$index, index)" @input="getShop(scope.$index, index)"></el-input>
                    <el-button class="el-icon-plus" size="mini" style="border:none;padding: 0" v-if="index == 0"
                      :disabled="verifyDisabled" @click="addProductCodeAlias(scope.row)"></el-button>
                    <el-button class="el-icon-minus" size="mini" style="border:none;padding: 0" v-else
                      @click="delProductCodeAlias(scope.row, index)"></el-button>
                  </el-row>
                </template>
              </el-table-column>
              <!-- <el-table-column label="商品库存" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.stockNum }}</p>
                </template>
              </el-table-column> -->
              <el-table-column label="状态" align="center" width="120">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.status" @change="hanleChange" clearable filterable>
                    <el-option v-for="item in goodList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="预估采购价格" align="center" width="70">
                <template slot="header" slot-scope="scope">
                  <el-button type="primary" size="mini" @click="setPrice(1)">同步</el-button>
                  预估采购价格
                </template>
                <template slot-scope="scope">
                  <el-input v-model.trim="scope.row.estimatedPurchasePrice" style="width: 100%"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="预估运费" align="center" width="70">
                <template slot="header" slot-scope="scope">
                  <el-button type="primary" size="mini" @click="setPrice(2)">同步</el-button>
                  预估运费
                </template>
                <template slot-scope="scope">
                  <el-input v-model.trim="scope.row.estimatedShipping" style="width: 100%"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="70" fixed="right">
                <template slot-scope="scope">
                  <el-button @click.native.prevent="
                    deleteRow(scope.row, scope.$index)
                  " type="text" style="border:none">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="beforeClose">取 消</el-button>
        <el-button type="primary" :loading="createBtnLoading" @click="save('form')">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="输入内容"
      :visible.sync="dialogVisibleAlias"
      width="30%"
      @close="handleDialogClose"
    >
      <!-- 输入框组件 -->
      <el-input v-model="inputValue" placeholder="请输入内容"></el-input>
        <!-- 确认和取消按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleDialogClose">取 消</el-button>
          <el-button type="primary" @click="saveInput">确 定</el-button>
        </span>
    </el-dialog>

    <el-dialog
      title="输入补充内容"
      :visible.sync="dialogVisibleAddAlias"
      width="30%"
      @close="handleDialogAddClose"
    >
      
        <div class="morePlatform">
          <el-select v-model="addAliasSellerType" @change="changeAliasPlatform" placeholder="请选择平台" filterable clearable>
            <el-option
              v-for="item in platform" 
              :key="item.sellerType" 
              :label="item.itemTypeName"
              :value="item.sellerType">
            </el-option>
          </el-select>
            
          <el-select 
            v-model="addAliasSellerId" 
            filterable
            clearable 
            @change="changeAliasShop" 
            placeholder="请选择店铺">
            <el-option v-for="ele in addAliasShopList" :key="ele.sellerId" :label="ele.shopName" :value="ele.sellerId">
            </el-option>
          </el-select>

        </div>
    
      

      <!-- 输入框组件 -->
      <el-input v-model="inputAddValue" placeholder="请输入内容"></el-input>
        <!-- 确认和取消按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleDialogAddClose">取 消</el-button>
          <el-button type="primary" @click="addInput">确 定</el-button>
        </span>
    </el-dialog>

    <!-- 预览图片 -->
    <el-dialog :visible.sync="ImageVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>

    <!-- 选择图片 -->
    <el-dialog title="选择图片" class="uploaderImgVariant" :visible.sync="dialogFormVisible" width="1000px"
      @close="variantSelectImgDialogClose">
      <!-- <el-alert title="变体图片最多选择9张" type="error" :closable="false"></el-alert> 取消限制-->
      <el-divider></el-divider>
      <ul class="select-img" v-if="imageData.length">
        <li class="option" v-for="(item, index) in imageData" :key="index" @click="changeVariantSelectImg(item, index)">
          <div class="img-mask" v-if="
            variantCheckedImgUidList.some((key) => key === item)
          ">
            <i class="el-icon-upload-success el-true-check">
              {{ getVariantSelectImgIndex(item) }}
            </i>
          </div>
          <img :src="item.url" alt />
        </li>
      </ul>
      <el-divider v-if="imageData.length"></el-divider>
      <el-upload class="custom-update" :action="action" accept="image/gif, image/jpeg, image/tiff, image/png, image/bpm" drag multiple
        :show-file-list="false" list-type="picture-card" :on-success="handleAvatarSuccess" :headers="customHeaders">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将图片拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          <p>
            图片可批量上传，只支持
            <span style="color:red;font-weight:bold;">JPG/TIFF/JPEG/PNG/BPM</span>
            格式图片，首选
            <span style="color:red;font-weight:bold;">JPEG</span>
            格式， 图片的最长边不应低于
            <span style="color:red;font-weight:bold;">1600</span>
            像素，最长边不得超过
            <span style="color:red;font-weight:bold;">10,000</span>
            像素，不能包含徽标或水印。商品必须是填满
            <span style="color:red;font-weight:bold;">85%</span>
            的图片,图片详细标准请参阅Amazon平台要求。
          </p>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="saveVariantSelectImg()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 提交图片 -->
    <el-dialog title="已选图片" class="uploaderImgVariant" :visible.sync="isShowVariantImg" width="1000px">
      <div class="image-container">
        <div class="img-box" v-for="item in variantImages" :key="item.uid">
          <img :src="item.data" />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowVariantImg = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="isShowVariantImg = false">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 变体 -->
    <el-dialog title="变体设置" :visible.sync="dialogVariantVisible">
      <div>
        变体名称:
        <el-select size="mini" v-model="specsIndex" placeholder="请选择变体名称" @change="getVariantSelect" clearable filterable>
          <el-option :label="item.title" :key="index" :value="item.title" v-for="(item, index) in specs"></el-option>
        </el-select>
      </div>
      <div style="margin-top: 10px">
        变体值:(多个值用逗号隔开如:red,white,black,)
        <br />
        <el-input placeholder="多个值用英文逗号隔开如:red,white,black" style="margin-top: 5px; margin-bottom: 5px; width: 70%"
          size="mini" type="texteara" v-model.trim="variantText"></el-input>
      </div>
      <div>
        <el-tabs class="rs-tab" v-if="recommendSpecs && recommendSpecs.length > 0" tab-position="left">
          <el-tab-pane v-for="(item, index) in recommendSpecs" :key="index" :label="item.title">
            <ul>
              <li style="padding: 0 3px; cursor: pointer" v-for="(sub_item, i) in item.list" v-text="sub_item"
                @click="putText(sub_item)" :key="i"></li>
            </ul>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="footer">
        <el-button @click="dialogVariantVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveVariantInfoEdit1">确 定</el-button>
      </div>
    </el-dialog>

    <!-- SKU设置 -->
    <el-dialog title="SKU设置" :visible.sync="dialogVisibleSKU" width="35%">
      <el-form ref="formSKU" :rules="rules" :model="formSKU" label-width="120px">
        <el-form-item label="品牌名称：">
          <el-input v-model.trim="formSKU.brandName" placeholder="请输入品牌名称"></el-input>
        </el-form-item>
        <el-form-item label="厂商名称：">
          <el-input v-model.trim="formSKU.vendorName" placeholder="请输入厂商名称"></el-input>
        </el-form-item>
        <el-form-item label="SKU编码前缀：" prop="prefix">
          <el-input v-model.trim="formSKU.prefix" placeholder="请输入SKU编码前缀"></el-input>
        </el-form-item>
        <el-form-item label="流水码起始数：" prop="InitialLlow">
          <el-input v-model.trim="formSKU.InitialLlow" placeholder="请输入流水码起始数"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisibleSKU = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('formSKU')">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 关联现有产品 -->
    <Associated ref="associated" @itemclick="cpnclick"></Associated>

    <!-- 查看详情 -->
    <checkInformation ref="checkInformation"></checkInformation>

    <!-- 分类列表 -->
    <ClassificationList ref="ClassificationList" @childvalue="childByvalue"></ClassificationList>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Associated from './AssociatedProducts.vue'
import checkInformation from './checkInformation'
import ClassificationList from './ClassificationList.vue'
import colorList from '../commodity/product/EstablishProductClassificationModular/Choice/colorList'
import sizeList from '../commodity/product/EstablishProductClassificationModular/Choice/sizeList'
import sleeveList from '../commodity/product/EstablishProductClassificationModular/Choice/sleeveSize'
import waistSize from '../commodity/product/EstablishProductClassificationModular/Choice/waistSize'
import { ajaxPost, Baseurl, ajaxGet } from '../../api/api/api'

export default {
  name: '',
  components: {
    Associated,
    checkInformation,
    ClassificationList,
    draggable
  },
  data() {
    return {
      addAliasShopList: [],
      addAliasSellerType: '',
      addAliasShopName: '',
      addAliasShopId: '',
      addAliasSellerId: '',
      dialogVisibleAlias: false, // 控制对话框的显示与隐藏
      dialogVisibleAddAlias: false, // 控制补充别名对话框的显示与隐藏
      inputValue: '', // 用于双向绑定输入框的值
      inputAddValue: '', // 用于双向绑定补充输入框的值
      inputArray: [], // 保存输入的内容数组
      inputAddArray: [], // 保存输入的补充内容数组
      goodList: [
        {
          id: 1, name: '在售'
        }, {
          id: 2, name: '停售'
        }, {
          id: 3, name: '试卖'
        }, {
          id: 4, name: '部分停售'
        }, {
          id: 5, name: '清仓'
        }, {
          id: 6, name: '部分清仓'
        }
      ],
      prefix: '',
      formSKU: {
        brandName: '',
        vendorName: '',
        prefix: '',
        InitialLlow: ''
      },
      dialogVisibleSKU: false,
      sleValue: '',
      show: true,
      type: 1,
      str: '',
      companyId: '',
      roleId: '',
      selectRidList: [],
      Selected_pictures_value: '', //已选图片选择变体的值
      ImageVisible: false,
      isShowVariantImg: false, //已选图片
      dialogImageUrl: [],
      dialogFormVisible: false, //选择图片
      action: Baseurl + "imageController/uploadImage",
      customHeaders: { token: localStorage.getItem("token") },
      dialogVisible: false,
      dialogVariantVisible: false,
      classification: {},
      // 颜色 和 尺寸 的先后顺序决定变体标识，不可换！！！
      selectVariants: {
        颜色: [],
        尺寸: [],
        袖长: [],
        腰长: []
      },
      imgList: [],
      iscenter: {
        textAlign: 'center',
        background: '#f8f8f8',
        color: '#232323',
      },
      recommendSpecs: {}, //显示尺寸和颜色的规格
      imageData: [],
      checked: false,
      specsIndex: '',
      variantText: '', //选择尺寸和颜色后获取的值
      form: {
        salesType: '2',
        goodsName: '',
        chineseName: '',
        productId: '',
        alias: '',
        model: '',
        goodsState: '1',
        supply: '',
        inventory: '0',
        description: '',
        note: '',
        associated: '',
        estimatedPurchasePrice: '',
        estimatedShipping: ''
      },
      List: {},
      rules: {
        goodsName: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        chineseName: [{ required: true, message: '请输入中文简称', trigger: 'blur' }],
        goodsState: [
          { required: true, message: '请选择商品状态', trigger: 'change' }
        ],
        prefix: [{ required: true, message: '请填写SKU编码前缀', trigger: 'blur' }],
        InitialLlow: [{ required: true, message: '请填写流水码起始数', trigger: 'blur' }]
      },
      productData: [],
      checkedStore: {},
      combinationProducts: [],
      aliasList: [{
        shopName: '',
        sellerType: '',
        shopId: '',
        productCodeAlias: '',
        ShopList: []
      }],
      zuhealiasList: [{
        shopName: '',
        sellerType: '',
        shopId: '',
        productCodeAlias: '',
        ShopList: [],
        aliasList: []
      }],
      urlList: [{ id: 1, value: '' }],
      summarylist: [],
      summarylistReset: [],
      SKUAttributable: [],
      variantCheckedImgUidList: [],
      variantImages: [], //已选图片
      classifications: [],
      checkedIndex: '',
      specs: [{ title: '颜色' }, { title: '尺寸' }, { title: '袖长' }, { title: '腰长' }],
      relatedItems: [],
      batch_select2: [],
      verifyDisabled: false,
      platform: [],
      platformlabel: {},
      zuheplatform: [],
      zuheshop: [],
      zuhealias: [],
      allShop: [],
      isDragging: false,
      imgListSelect: [],
      createBtnLoading: false,
      verifyDisabledMsg: '',
      deleteId: [],
      aliasDetailVO: []
    }
  },
  computed: {
    isSyncInfoList() {
      let bool = []
      this.specs.map(item => {
        if (this.selectVariants[item.title].length) bool.push(1)
      })
      if (bool.length > 1) {
        return true
      } else {
        return false
      }
      // for (const item in this.selectVariants) {
      //   if (!this.selectVariants[item].length) {
      //     return false
      //   }
      // }
      // return true
    },
    isShowColor() {
      return this.summarylist.length && this.summarylist[0].color
    },
    isShowSize() {
      return this.summarylist.length && this.summarylist[0].size
    },
    isShowSleeve() {
      return this.summarylist.length && this.summarylist[0].sleeve
    },
    isShowWaist() {
      return this.summarylist.length && this.summarylist[0].waist
    },
  },
  created() {
    this.str = JSON.parse(localStorage.getItem('role'))
    this.roleId = this.str.rid
    this.companyId = this.str.company_id
    this.allShop = []
    this.getPlatForm()
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.handleRadio('1')
        this.selectVariants = {
          颜色: [],
          尺寸: [],
          袖长: [],
          腰长: []
        }
      }
    }
  },
  methods: {
    // 获取平台
    async getPlatForm(){
      const API = Baseurl + 'sellerController/selectSellerTypeByRid'
      const paramsData = {
        rid: this.str.rid
      }
      ajaxPost(API, paramsData)
        .then((res) => {
          if (res.data.code === 200) {
            this.platform = res.data.data
            this.platform.map(ele => {
              this.getAllShop(ele.sellerType)
            })
          } else {
            this.$message.error(res.data.data)
          }
        })
    },
     openDialog() {
      // 打开对话框事件
      this.dialogVisibleAlias = true;
    },
    addDialog() {
      // 打开补充别名对话框事件
      this.dialogVisibleAddAlias = true;
    },
    handleDialogClose() {
      // 对话框关闭事件
      this.dialogVisibleAlias = false;
    },
      handleDialogAddClose() {
      // 补充对话框关闭事件
      this.dialogVisibleAddAlias = false
    },
    changeAliasPlatform(event) {
      if(event) {
        // console.log(this.allShop);
        const findShop = this.allShop.find(item => item.sellerType === event)
        // console.log(findShop);
        if(findShop) {
          this.addAliasShopList = findShop.shop
          this.addAliasSellerType = event
        } else {
          this.addAliasShopList = []
          this.addAliasSellerType = ''
        }
      } else {
        this.addAliasShopList = []
        this.addAliasSellerType = ''
      }
      
     
      // console.log(this.addAliasShopList);
    },
    changeAliasShop(event) {
      if(event) {
        // console.log(event);
        this.addAliasSellerId = event
        this.addAliasShopName = this.addAliasShopList.find(item => item.sellerId === event).shopName
        this.addAliasShopId = this.addAliasShopList.find(item => item.sellerId === event).shopId
        // console.log(this.addAliasSellerId);
        // console.log(this.addAliasShopName);
      }
      
    },
    saveInput() {
      // 保存输入的内容到数组
      this.inputArray = this.inputValue.split(' ')

      // 关闭对话框
      this.handleDialogClose();

      // 可以在这里将 this.inputArray 传递给其他需要使用的地方
      // console.log('保存的数组:', this.inputArray);
      this.setShop()

    },
    addInput() {
      // 保存输入的补充内容到数组
      this.inputAddArray = this.inputAddValue.split(' ')

      // 关闭对话框
      this.handleDialogAddClose();

      // 可以在这里将 this.inputArray 传递给其他需要使用的地方
      // console.log('保存的数组:', this.inputAddArray);
      // console.log('所有的店铺:', this.allShop);
      // this.setShop()
      this.summarylist.map((item, index) => {
        item.aliasDetailVO.push({
          productCodeAlias: this.inputAddArray[index],
          sellerId: this.addAliasSellerId,
          sellerType: this.addAliasSellerType,
          shopId: this.addAliasShopId,
          shopName: this.addAliasShopName,

        })
      })
      this.addAliasSellerType = ''
      this.addAliasSellerId = ''
      this.addAliasShopName = ''
      this.addAliasShopId = ''
      this.inputAddValue = ''
      this.inputAddArray = []
      // console.log(this.summarylist);

    },
    // updateAliasDetailVO() {
    //   const newValues = [{ productCodeAlias: '002' }]
    //   this.aliasDetailVO = newValues;
    // },
    showImgDialog() {
      this.checkedIndex = -1
      this.dialogFormVisible = true
    },
    handlePictureCardPreview(file) {
			let imageUrl = ''
			if (Object.prototype.toString.call(file) === '[object Object]') {
				imageUrl = file.response.data
			} else {
				imageUrl = file
			}
			this.dialogImageUrl = imageUrl
			this.ImageVisible = true
		},
    handleRemoveSelect(index) {
			this.imgListSelect.splice(index, 1)
		},
    on_batch_select(val) {
      this.batch_select2 = val;
    },
    OneOperation() {
      if (this.batch_select2.length != 0) {
        if (this.sleValue != '') {
          this.batch_select2.forEach((item) => {
            item.status = this.sleValue
          })
        } else {
          this.$message.warning('请选择一条产品状态')
        }
      } else {
        this.$message.warning('请选择一条产品')
      }
    },
    hanleChange(val) {
      this.summarylist.forEach(item => {
        if (item.status == val) {
          this.sleValue = item.status
        }
      })
    },
    selectClassification() {
      this.$refs.ClassificationList.init()
    },
    editCheck(row) {
      this.$refs.checkInformation.init(row.id)
    },
    getCommonSetting() {
      const API = Baseurl + 'commonSettingController/getCommonSettingByStaffIdAndType'
      const paramsData = {
        staffId: this.roleId,
        type: 15
      }
      ajaxPost(API, paramsData)
        .then((res) => {
          if (res.data.code === 200) {
            this.formSKU.brandName = res.data.data.field01
            this.formSKU.vendorName = res.data.data.field02
            this.formSKU.prefix = res.data.data.field03
            this.formSKU.InitialLlow = res.data.data.pipeCode.replace(/\b(0+)/gi, "")
            this.prefix = res.data.data.field03 + res.data.data.pipeCode
          } else {
            this.$message.error(res.data.data)
          }
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          ajaxPost(Baseurl + "commonSettingController/setShopifyCommonSetting", {
            type: 15,
            staffId: this.roleId,
            companyId: this.companyId,
            field01: this.formSKU.brandName,
            field02: this.formSKU.vendorName,
            field03: this.formSKU.prefix,
            pipeCode: this.formSKU.InitialLlow.replace(/\b(0+)/gi, ""),
          }).then(res => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "设置成功!",
              });
              this.dialogVisibleSKU = false
              this.getCommonSetting()
            } else {
              this.$message({
                type: "error",
                message: res.data.data,
              });
            }
          });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    handleCheck() {
      if (this.form.goodsName != '') {
        if (this.checked == true) {
          this.form.chineseName = this.form.goodsName
        } else {
          this.form.chineseName = ''
        }
      } else {
        this.$message.warning('请填写商品名称')
        this.checked = false
      }
    },
    delData(_, index) {
      if (this.productData.length < 3) {
        this.$message.error("捆绑产品最少两条！")
        return
      }
      this.productData.splice(index, 1)
      this.classifications.splice(index, 1)
    },
    deleteRow1(_, index) {
      this.SKUAttributable.splice(index, 1)
    },
    addProductCodeAlias(val) {
      val.aliasDetailVO.push({
        productCodeAlias: ''
      })
      this.verifyDisabled = false
    },
    delProductCodeAlias(item, index) {
      item.aliasDetailVO.splice(index, 1)
    },
    //选择开始时间
    startTime(val, row) {
      var d = new Date(val)
      var datetime =
        d.getFullYear() +
        '-' +
        (d.getMonth() + 1) +
        '-' +
        d.getDate() +
        ' 00:00:00'
      row.startTime = datetime
    },
    employeesAjax() {
      const API = Baseurl + 'roleController/selectSubordinateByRid'
      const paramsData = {
        companyId: this.companyId,
        rid: this.roleId,
        system: this.str.system
      }

      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.selectRidList = res.data.data
        } else {
          this.$message.error(data || '操作失败')
        }
      })
    },
    handleBtn(val, row) {
      if (val === 'enable') {
        row.disabled = false
        row.status = 1
      } else {
        row.disabled = true
        row.status = 2
      }
    },
    childByvalue(value) {
      this.classification = value
    },
    //变体图片应用至
    Selected_picturesSame(val, item) {
      let productSkuImages = item.productSkuImages
      if (val === 'all_variant') {
        this.summarylist.map((ele) => {
          this.$set(ele, 'productSkuImages', productSkuImages)
        })
      } else {
        let selectType = ''
        if (val === '颜色') {
          selectType = item.color
        } else if (val === '尺寸') {
          selectType = item.size
        } else if (val === '袖长') {
          selectType = item.sleeve
        } else if (val === '腰长') {
          selectType = item.waist
        }
        this.summarylist.forEach((item2) => {
          const variantTagArr = item2.productVariantMarker.split('-')
          const result = variantTagArr.includes(selectType)
          if (result) {
            this.$set(item2, 'productSkuImages', productSkuImages)
          }
        })
      }
      this.$message.success('操作成功')
      this.Selected_pictures_value = ''
    },
    // 已选图片
    Selected_pictures(item) {
      this.isShowVariantImg = true
      this.variantImages = item.productSkuImages
    },
    // 删除图片
    handleRemove1(item, index) {
      item.productSkuImages.splice(index, 1)
    },
    changeVariantSelectImg(item) {
      if (this.variantCheckedImgUidList.length <= 0) {
        this.variantCheckedImgUidList.push(item)
      } else {
        const isHaveIndex = this.variantCheckedImgUidList.findIndex(
          (key) => key === item
        )
        if (isHaveIndex > -1) {
          this.variantCheckedImgUidList.splice(isHaveIndex, 1)
        } else {
          this.variantCheckedImgUidList.push(item)
          // if (this.variantCheckedImgUidList.length < 9) {
          //   this.variantCheckedImgUidList.push(item)
          // } else {
          //   this.$message.error('变体图片最多选择9张')
          // }
        }
      }
    },
    getVariantSelectImgIndex(item) {
      const isHaveIndex = this.variantCheckedImgUidList.findIndex(
        (key) => key === item
      )
      return isHaveIndex + 1
    },
    // 选择图片确定
    saveVariantSelectImg() {
      this.dialogFormVisible = false
      this.variantCheckedImgUidList.forEach(item => {
        item.data = item.url
      })
      if (this.checkedIndex != -1) {
        this.summarylist.forEach((item,index) => {
          if(this.checkedIndex === index) {
            item.productSkuImages = this.variantCheckedImgUidList
          }
        })
      } else {
        this.imgListSelect = JSON.parse(JSON.stringify(this.variantCheckedImgUidList))
      }
      this.imgList = this.imageData
      this.variantCheckedImgUidList = []
    },
    Select_pictures(row, index) {
      this.imageData = JSON.parse(JSON.stringify(this.imgList))
      this.checkedIndex = index
      this.dialogFormVisible = true
    },
    variantSelectImgDialogClose() {
      this.variantCheckedImgUidList = []
    },
    cpnclick(id, row) {
      this.classifications = id
      if (this.productData.length == 0) {
        this.productData = row
      } else {
        row.forEach(item => {
          this.productData.push(item)
        })
      }
      this.zuheplatform = []
      this.zuheshop = []
      this.zuhealias = []
      this.productData.map(item => {
        if (item.productImages && item.productImages.length) {
          item.productImages.map(element => {
            this.imageData.push({
              url: element
            })
          })
        }
        if (item.productSkuImages && item.productSkuImages.length) {
          item.productSkuImages.map(element => {
            this.imageData.push({
              url: element
            })
          })
        }
        if (item.aliasDetailVO) {
          item.aliasDetailVO.map(ele => {
            if (!this.zuheplatform.some(x => x.sellerType == ele.sellerType)) {
              this.zuheplatform.push({
                sellerType: ele.sellerType,
                itemTypeName: this.platformlabel[ele.sellerType]
              })
            }

            if (!this.zuheshop.some(x => x.sellerId == ele.sellerId)) {
              this.zuheshop.push({
                sellerId: ele.sellerId,
                sellerType: ele.sellerType,
                shopName: ele.shopName
              })
            }

            if (!this.zuhealias.some(x => x.variantId == ele.variantId)) {
              this.zuhealias.push({
                variantId: ele.variantId,
                alias: ele.alias,
                sellerId: ele.sellerId
              })
            }
            
          })
        }
      })
    },
    changezuhePlatform(index) {
      this.zuhealiasList[index].ShopList = this.zuheshop.filter(x => x.sellerType == this.zuhealiasList[index].sellerType)
    },
    shopzuheChange(index) {
      this.zuhealiasList[index].aliasList = this.zuhealias.filter(x => x.sellerId == this.zuhealiasList[index].shopId)
    },
    zuhezuhealiasList() {
      this.zuhealiasList.push({
        shopName: '',
        sellerType: '',
        shopId: '',
        productCodeAlias: '',
        ShopList: [],
        aliasList: []
      })
    },
    delzuhealiasList(i) {
      this.zuhealiasList.splice(i, 1)
    },
    init(row) {
      if (row) {
        this.show = false
        this.editProduct(row.id)
        this.verifyDisabled = false
        if (row.salesType === 1) {
          this.form.salesType = '1'
        } else if (row.salesType === 4) {
          this.form.salesType = '4'
        } else if (row.salesType === 2) {
          this.form.salesType = '2'
        } else {
          this.form.salesType = '3'
        }
      } else {
        this.show = true
        this.form = {
          salesType: '2',
          goodsName: '',
          chineseName: '',
          productId: '',
          alias: '',
          model: '',
          goodsState: '1',
          supply: '',
          inventory: '0',
          description: '',
          note: '',
          associated: ''
        }
        this.productData = []
        this.imgList = []
        this.List = ''
        this.imageData = []
        this.aliasList = [{
          shopName: '',
          sellerType: '',
          shopId: '',
          productCodeAlias: '',
          ShopList: []
        }]
        this.SKUAttributable = []
        this.summarylist = []
        this.urlList = [{ id: 1, value: '' }]
        this.classification = {}
        this.getCommonSetting()
        this.classifications = []
        
        this.verifyDisabled = false
        this.dialogVisible = true
      }
      this.type = 1
      this.checked = false
      this.relatedItems = []
      this.employeesAjax()
    },
    verifyAlias(val, sellerType, shopId, type, index1, index2 = 0) {
      if (!val) {
        return
      }
      if (type == 1) {
        let num = 0
        this.aliasList.map(item => {
          if (item.productCodeAlias == val) num++
        })
        if (num > 1) {
          this.aliasList[index1].productCodeAlias = ''
          this.$alert('该别名已存在', '提示', {
            confirmButtonText: '确定'
          })
          return
        }
      } else {
        let num = 0
        this.summarylist.map(item => {
          if (item.aliasDetailVO && item.aliasDetailVO.length) {
            item.aliasDetailVO.map(ele => {
              if (ele.productCodeAlias == val) num++
            })
          }
        })
        if (num > 1) {
          this.summarylist[index1].aliasDetailVO[index2].productCodeAlias = ''
          this.$alert('该别名已存在', '提示', {
            confirmButtonText: '确定'
          })
          return
        }
      }
      if (!sellerType || !shopId) return
      if (val) {
        let API = Baseurl + 'systemProduct/verifyAlias?sellerType='+ sellerType +'&sellerId=' + shopId + '&alias=' + val
        ajaxGet(API)
          .then((res) => {
            if (res.data.code === 1 && res.data.data === null) {
              this.verifyDisabled = false
              this.verifyDisabledMsg = ''
            } else {
              this.verifyDisabled = true
              const obj = res.data.data
              this.verifyDisabledMsg = `${this.platformlabel[obj.sellerType]}平台下，${obj.shopName}店铺下，别名“${obj.alias}”重复！`
              this.$alert(this.verifyDisabledMsg, '提示', {
                confirmButtonText: '确定'
              })
              // this.$message.error(this.verifyDisabledMsg)
            }
          })
      }
    },
    getShop(index, i) {
      const API = Baseurl + 'systemProduct/selectSellerInfoByAlias'
      ajaxPost(API, {alias: this.summarylist[index].aliasDetailVO[i].productCodeAlias}).then(res => {
        if (res.data.data.sellerType) {
          this.summarylist[index].aliasDetailVO[i].sellerType = res.data.data.sellerType
          this.changeVariantPlatform(i, index)
        }
        if (res.data.data.shop_name) {
          this.summarylist[index].aliasDetailVO[i].shopName = res.data.data.shop_name
          this.shopVariantChange(i, index)
        }
      })
    },
    editProduct(id) {
      const API = Baseurl + 'systemProduct/get/' + id
      ajaxGet(API)
        .then((res) => {
          if (res.data.code === 1) {
            this.List = res.data.data
            if (this.List.variants && this.List.variants.length) {
              this.List.variants.map(el => {
                el.aliasDetailVO.map(ele => {
                  this.$set(ele, 'productCodeAlias', ele.alias)
                  this.$set(ele, 'shopId', ele.sellerId)
                })
              })
              this.aliasList = JSON.parse(JSON.stringify(this.List.variants[0].aliasDetailVO))
            }
            if (!this.aliasList.length) {
              this.aliasList = [{
                shopName: '',
                sellerType: '',
                shopId: '',
                productCodeAlias: '',
                ShopList: []
              }]
            }
            this.dialogVisible = true
            this.prefix = this.List.skuPrex
            this.classification.joinName = this.List.categoryName
            const img = this.List.productImages.split(',')
            const imageList = img.map(item => ({
              url: item
            }))
            this.imgList = JSON.parse(JSON.stringify(imageList))
            this.imageData = JSON.parse(JSON.stringify(imageList))
            this.imgListSelect = JSON.parse(JSON.stringify(imageList))
            // this.imageData = this.imgList
            this.form.goodsName = this.List.title
            this.form.chineseName = this.List.abbreviation
            this.form.productId = this.List.productCode
            if (this.List.salesType == '1' || this.List.salesType == '3') {
              this.aliasList.forEach((item, index) => {
                this.$set(item, 'ShopList', [])
                let s = index == 0 ? 1500 : (index + 1) * 1500
                setTimeout(() => {
                  this.SelectTheStore(index, false)
                }, s)
              })
            } else if (this.List.salesType == '2') {
              // this.allShop = []
              // this.platform.map((ele, ind) => {
              //   let s = ind == 0 ? 1500 : (ind + 1) * 1500
              //   setTimeout(() => {
              //     this.getAllShop(ele.sellerType)
              //   }, s)
              // })
              
              if (this.allShop.length == 3 && this.List.id) {
                this.List.variants.forEach(item => {
                  if (item.aliasDetailVO && item.aliasDetailVO.length) {
                    item.aliasDetailVO.map(ele => {
                      this.allShop.map(e => {
                        if (e.sellerType == ele.sellerType) {
                          this.$set(ele, 'ShopList', e.shop)
                        }
                      })
                    })
                  }
                })
              }
              // console.log(this.List.variants, 'this.selectVariants');
              this.List.variants.forEach((item, index) => {
                let variantData = JSON.parse(item.variantData)
                if (variantData.color) {
                  this.$set(item, 'color', variantData.color)
                  if (!this.selectVariants.颜色.includes(variantData.color)) {
                    this.selectVariants.颜色.push(variantData.color)
                  }
                }
                if (variantData.size) {
                  this.$set(item, 'size', variantData.size)
                  if (!this.selectVariants.尺寸.includes(variantData.size)) {
                    this.selectVariants.尺寸.push(variantData.size)
                  }
                }
                if (variantData.sleeve) {
                  this.$set(item, 'sleeve', variantData.sleeve)
                  if (!this.selectVariants.袖长.includes(variantData.sleeve)) {
                    this.selectVariants.袖长.push(variantData.sleeve)
                  }
                }
                if (variantData.waist) {
                  this.$set(item, 'waist', variantData.waist)
                  if (!this.selectVariants.腰长.includes(variantData.waist)) {
                    this.selectVariants.腰长.push(variantData.waist)
                  }
                }
                const img = item.variantImages.split(',')
                if (item.variantImages) {
                  item.variantImages = img.map(key => ({
                    data: key,
                    url: key
                  }))
                }
                this.$set(item, 'productSkuImages', item.variantImages)
              })
              // console.log(this.selectVariants, 'this.selectVariants');
              // this.List.variants.map(item => {
              //   item.aliasDetailVO.map(ele => {
              //     this.$set(ele, 'ShopList', [])
              //   })
              // })
              this.summarylist = this.List.variants
              this.summarylistReset = JSON.parse(JSON.stringify(this.List.variants))
            }
            this.form.model = this.List.sizeModel
            this.form.goodsState = this.List.status.toString()
            const sourceUrl = this.List.sourceUrl.split(',')
            const arr = sourceUrl.map(item => ({
              value: item
            }))
            this.urlList = arr
            this.form.description = this.List.productDescription
            this.form.note = this.List.remark
            // this.SKUAttributable = this.List.itemsBelonger
            // this.SKUAttributable.forEach(item => {
            //   item.disabled = item.status == 2 ? true : false
            // })
            this.List.relationDetails?.map(ele => {
              this.$set(ele, 'productImages', ele.variantImages ? ele.variantImages.split(',') : ele.variantImages)
              if (ele.productImages) {
                ele.productImages.map(url => {
                  this.imageData.push({url})
                })
              }
              this.$set(ele, 'stockNum', ele.quantity)
            })
            this.productData = this.List.relationDetails
            if (this.List.salesType == '1' || this.List.salesType == '3') {
              this.form.model = this.List.variants[0].sizeModel
              this.form.estimatedPurchasePrice = this.List.variants[0].estimatedPurchasePrice
              this.form.estimatedShipping = this.List.variants[0].estimatedShipping
            }
            if (this.List.salesType == '3') {
              this.classifications = []
              this.List.relationDetails.map(eleme => {
                this.classifications.push({
                  combinationId: eleme.basicVariantId,
                  stockNum: eleme.quantity
                })
              })
            }
            if (this.List.salesType == '5') {
              
              this.zuheplatform = []
              this.zuheshop = []
              this.zuhealias = []
              this.List.productList.map(item => {
                item.aliasDetailVO.map(ele => {
                  if (!this.zuheplatform.some(x => x.sellerType == ele.sellerType)) {
                    this.zuheplatform.push({
                      sellerType: ele.sellerType,
                      itemTypeName: this.platformlabel[ele.sellerType]
                    })
                  }

                  if (!this.zuheshop.some(x => x.sellerId == ele.sellerId)) {
                    this.zuheshop.push({
                      sellerId: ele.sellerId,
                      sellerType: ele.sellerType,
                      shopName: ele.shopName
                    })
                  }

                  if (!this.zuhealias.some(x => x.sellerId == ele.sellerId)) {
                    this.zuhealias.push({
                      variantId: ele.variantId,
                      alias: ele.alias,
                      sellerId: ele.sellerId
                    })
                  }
                  
                })
              })

              this.zuhealiasList = []
              this.List.variants[0].aliasDetailVO.map(elem => {
                this.zuhealiasList.push({
                  shopName: elem.shopName,
                  sellerType: elem.sellerType,
                  shopId: elem.sellerId,
                  productCodeAlias: elem.alias,
                  ShopList: this.zuheshop.filter(x => x.sellerType == elem.sellerType),
                  aliasList: this.zuhealias.filter(x => x.sellerId == elem.sellerId)
                })
              })
              this.classifications = []
              this.List.relationDetails.map(eleme => {
                this.classifications.push({
                  combinationId: eleme.basicVariantId,
                  stockNum: eleme.quantity
                })
              })
            }
          } else {
            this.$message.error(res.data.message)
          }
        })
    },
    shopChange(index) {
      let shop = this.aliasList[index].ShopList.find(item => item.shopName === this.aliasList[index].shopName)
      this.$set(this.aliasList[index], 'shopId', shop.sellerId)
      this.checkedStore = this.aliasList[index]
    },
    shopVariantChange(index, ind) {
      this.checkedStore = this.summarylist[ind].aliasDetailVO[index]
      this.summarylist[ind].aliasDetailVO[index].ShopList.map(item => {
        if (item.shopName === this.summarylist[ind].aliasDetailVO[index].shopName) {
          this.$set(this.summarylist[ind].aliasDetailVO[index], 'shopId', item.sellerId)
        }
      })
    },
    changeVariantPlatform(index, ind) {
      this.summarylist[ind].aliasDetailVO[index].shopName = ''
      let sellerType = this.summarylist[ind].aliasDetailVO[index].sellerType
      this.$set(this.summarylist[ind].aliasDetailVO[index], 'ShopList', this.allShop.filter(x => x.sellerType == sellerType)[0].shop);
      // var param = {
      //   rid: this.str.rid,
      //   system: this.str.system,
      //   sellerType
      // };
      // ajaxPost(Baseurl + "sellerController/selectSellerByRid", param).then(res => {
      //   const { code, data } = res.data;
      //   if (code === 200) {
      //     if (!data.length) return;
      //     var sellerInfos = data;
      //     var newArr = [];
      //     var num = 0;
      //     for (var i = 0; i < sellerInfos.length; i++) {
      //       var shop = sellerInfos[i].countryMarks;
      //       for (var j = 0; j < shop.length; j++) {
      //         shop[j].sellerId = sellerInfos[i].sellerId;
      //         shop[j].mwsAuthToken = sellerInfos[i].mwsAuthToken;
      //         newArr[num] = shop[j];
      //         num++;
      //       }
      //     }
          // this.$set(this.summarylist[ind].aliasDetailVO[index], 'ShopList', newArr.sort((a, b) => a.order - b.order));
      //   }
      // });
    },
    getAllShop(sellerType) {
      var param = {
        rid: this.str.rid,
        system: this.str.system,
        sellerType: sellerType
      };
      ajaxPost(Baseurl + "sellerController/selectSellerByRid", param).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          if (data && data.length) {
            var sellerInfos = data;
            var newArr = [];
            var num = 0;
            for (var i = 0; i < sellerInfos.length; i++) {
              var shop = sellerInfos[i].countryMarks;
              for (var j = 0; j < shop.length; j++) {
                shop[j].sellerId = sellerInfos[i].sellerId;
                shop[j].mwsAuthToken = sellerInfos[i].mwsAuthToken;
                newArr[num] = shop[j];
                num++;
              }
            }
            this.allShop.push({ sellerType, shop: newArr.sort((a, b) => a.order - b.order) })
          } else {
            this.allShop.push({ sellerType, shop: [] })
          }
        } else {
          this.allShop.push({ sellerType, shop: [] })
        }
      }).catch(() => {this.allShop.push({ sellerType, shop: [] })})
    },
    changePlatform(index) {
      this.SelectTheStore(index)
    },
    deleteRow(row, index) {
      if (row.variantId) {
        this.$confirm("此操作将永久删除此变体,如果有捆绑产品捆绑了该变体会影响到捆绑产品,是否确定删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.deleteId.push(row.variantId)
            this.summarylist.splice(index, 1)
          })
      } else {
        this.summarylist.splice(index, 1)
      }
    },
    SelectTheStore(index, bool = true) {
      if (bool) this.aliasList[index].shopName = ''
      let sellerType = this.aliasList[index].sellerType
      this.aliasList[index].ShopList = this.allShop.filter(x => x.sellerType == sellerType)[0].shop
      // this.addAliasSellerType = sellerType
      // console.log(this.aliasList[index].ShopList);
      // console.log(this.addAliasSellerType);

      // if (!sellerType) return
      // var param = {
      //   rid: this.str.rid,
      //   system: this.str.system,
      //   sellerType
      // };
      // ajaxPost(Baseurl + "sellerController/selectSellerByRid", param).then(res => {
      //   const { code, data } = res.data;
      //   if (code === 200) {
      //     if (!data.length) return;
      //     var sellerInfos = data;
      //     var newArr = [];
      //     var num = 0;
      //     for (var i = 0; i < sellerInfos.length; i++) {
      //       var shop = sellerInfos[i].countryMarks;
      //       for (var j = 0; j < shop.length; j++) {
      //         shop[j].sellerId = sellerInfos[i].sellerId;
      //         shop[j].mwsAuthToken = sellerInfos[i].mwsAuthToken;
      //         newArr[num] = shop[j];
      //         num++;
      //       }
      //     }
      //     this.aliasList[index].ShopList = newArr.sort((a, b) => a.order - b.order);
      //   }
      // });
    },
    EditSave() {
      if (this.form.salesType == '1') {
        this.aliasList.forEach(item => {
          item.ShopList.forEach(key => {
            if (item.shopName === key.shopName) {
              this.$set(item, "shopId", key.sellerId)
              this.$set(item, "companyId", this.companyId)
            }
          })
        })
        const relatedItems1 = ({
          aliasDetailVO: this.aliasList,
          productCode: this.form.productId,
          companyId: this.companyId
        })
        this.relatedItems.push(relatedItems1)
      } else if (this.form.salesType == '2') {
        this.summarylist.forEach(item => {
          // if (item.productSkuImages) {
          //   console.log(item);
          //   const res = item.productSkuImages.map((key) => {
          //     return key.data
          //   })
          //   item.productSkuImages = res.join(',')
          // }
          this.$set(item, "companyId", this.companyId)
          this.$set(item, "productCode", item.variantCode)
          if (item.productCode) {
            this.$set(item, "variantSku", this.prefix + '-' + item.productVariantMarker + '-' + item.productCode)
          } else {
            this.$set(item, "variantSku", this.prefix + '-' + item.productVariantMarker)
          }
          this.$set(item, "shopifyVariantData", { color: item.color, size: item.size, sleeve: item.sleeve, waist: item.waist })
          item.aliasDetailVO.forEach(key => {
            if (key.ShopList && key.ShopList.length) {
              key.ShopList.map(e => {
                if (key.shopName === e.shopName) {
                  this.$set(key, "shopId", e.sellerId)
                }
              })
            }
          })
        })
        this.relatedItems = this.summarylist
      }
    },
    save(formName) {
      if (JSON.stringify(this.classification) == '{}') {
        this.$message.error("请先选择分类！")
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let sourceUrl = ''
          const result = this.urlList.map(
            (item) => item.value
          )
          sourceUrl = result.join(',')
          let variants = []
          let combinationProducts = []
          if (this.form.salesType == '3' || this.form.salesType == '4') {
            if (this.classifications) {
              this.classifications.forEach(item => {
                this.productData.forEach(key => {
                  if (item.combinationId === key.id) {
                    item.stockNum = key.stockNum
                    if (key.productSkuImages) {
                      item.productImages = key.productSkuImages.join(',')
                    }
                    item.productCode = key.productCode
                  }
                  if (key.variantAlia) {
                    if (item.combinationId === key.variantAlia[0].id) {
                      item.stockNum = key.stockNum
                      if (key.productSkuImages) {
                        item.productImages = key.productSkuImages.join(',')
                      }
                      item.productCode = key.productCode
                    }
                  }
                })
              })
              this.classifications.map(ele => {
                combinationProducts.push({
                  basicVariantId: ele.combinationId,
                  quantity: ele.stockNum
                })
              })
              if (combinationProducts.length <= 1) {
                this.$message.error("捆绑产品至少捆绑两条！")
                return
              }
            }
          }
          if (this.form.salesType == '1' || this.form.salesType == '3') {
            let variantIdvariantId = ''
            if (this.List) {
              if (this.List.variants) {
                variantIdvariantId = this.List.variants[0].variantId
              }
            }
            variants = [
              {
                alias: [],
                variantId: variantIdvariantId,
                sizeModel: this.form.model,
                stock: this.form.inventory,
                estimatedPurchasePrice: this.form.estimatedPurchasePrice,
                estimatedShipping: this.form.estimatedShipping
              }
            ]
            this.aliasList.map(ele => {
              if (ele.productCodeAlias && ele.shopId && ele.sellerType) {
                variants[0].alias.push({
                  id: ele.id ? ele.id : '',
                  alias: ele.productCodeAlias,
                  sellerId: ele.shopId,
                  sellerType: ele.sellerType
                })
              }
            })
          }
          if (this.form.salesType == '5') {
            variants = [
              {
                alias: [],
                sizeModel: this.form.model,
                stock: this.form.inventory
              }
            ]
            this.zuhealiasList.map(ele => {
              variants[0].alias.push({
                alias: ele.productCodeAlias,
                sellerId: ele.shopId,
                sellerType: ele.sellerType
              })
            })
            this.verifyDisabled = false
          }
          if (this.imgListSelect.length === 0) {
            this.$message.warning('请上传商品图片')
            return
          } else if (!this.prefix) {
            this.$message.warning('请设置SKU编码前缀')
            return
          } else {
            if (this.List) {
              let Imgs = ''
              const Img = this.imgListSelect.map(
                (item) => item.url
              )
              Imgs = Img.join(',')
              this.EditSave()
              if (this.verifyDisabled) {
                // this.$message.warning('sku别名重复，请重新输入')
                this.$message.error(this.verifyDisabledMsg)
                return
              } else {
                if (this.form.salesType == '2') {
                  variants = []
                  let isRequire = false
                  this.relatedItems.map(ele => {
                    let alias = []
                    ele.aliasDetailVO.map(e => {
                      if (e.productCodeAlias || e.shopId || e.sellerType) {
                        if(!e.productCodeAlias || !e.shopId || !e.sellerType) {
                          isRequire = true
                        }
                      }
                      alias.push({
                        id: e.id ? e.id : '',
                        alias: e.productCodeAlias,
                        sellerId: e.shopId,
                        sellerType: e.sellerType
                      })
                    })
                    variants.push({
                      variantId: ele.variantId ? ele.variantId : '',
                      variantSku: ele.variantSku,
                      variantData: ele.shopifyVariantData,
                      variantCode: ele.variantCode,
                      stock: ele.stock,
                      status: ele.status,
                      estimatedPurchasePrice: ele.estimatedPurchasePrice,
                      estimatedShipping: ele.estimatedShipping,
                      variantImages: ele.productSkuImages ? ele.productSkuImages?.map(x => x.url).join(",") : '',
                      productVariantMarker: ele.productVariantMarker,
                      alias
                    })
                  })
                  if (isRequire) {
                    this.$message.error('请补充完整SKU别名再提交！')
                    return
                  }
                }
                const API = Baseurl + 'systemProduct/update'
                let paramsData = {
                  id: this.List.id,
                  salesType: this.form.salesType,
                  productImages: Imgs,
                  productImage: this.imgListSelect[0].url,
                  title: this.form.goodsName,
                  abbreviation: this.form.chineseName,
                  productCode: this.form.productId,
                  categoryId: this.classification.id,
                  categoryName: this.classification.name,
                  sizeModel: this.form.model,
                  status: this.form.goodsState,
                  sourceUrl: sourceUrl,
                  stockNum: this.form.inventory,
                  productDescription: this.form.description,
                  remark: this.form.note,
                  roleId: this.roleId,
                  combinationProducts,
                  // relatedItems: this.relatedItems,
                  variants,
                  itemsBelonger: this.SKUAttributable
                }
                if (this.deleteId.length) {
                  this.$set(paramsData, 'deleteId', this.deleteId)
                }
                this.createBtnLoading = true
                ajaxPost(API, paramsData)
                  .then((res) => {
                    if (res.data.code === 1) {
                      this.dialogVisible = false
                      this.$message.success('编辑成功')
                      this.$emit('fatherMethod');
                      this.deleteId = []
                    } else {
                      this.$message.error(res.data.message)
                    }
                    this.createBtnLoading = false
                  }).catch(() => {
                    this.$alert('服务报错，请联系客服。', '提示', {
                      confirmButtonText: '确定'
                    });
                    this.createBtnLoading = false
                  })
              }
            } else {
              let Imgs = ''
              const Img = this.imgListSelect.map(
                (item) => item.data
              )
              Imgs = Img.join(',')
              this.EditSave()
              if (this.verifyDisabled) {
                // this.$message.warning('sku别名重复，请重新输入')
                this.$message.error(this.verifyDisabledMsg)
                return
              } else {
                if (this.form.salesType == '2') {
                  variants = []
                  let isRequire = false
                  this.relatedItems.map(ele => {
                    let alias = []
                    ele.aliasDetailVO.map(e => {
                      if (e.productCodeAlias || e.shopId || e.sellerType) {
                        if(!e.productCodeAlias || !e.shopId || !e.sellerType) {
                          isRequire = true
                        }
                      }
                      alias.push({
                        alias: e.productCodeAlias,
                        sellerId: e.shopId,
                        sellerType: e.sellerType
                      })
                    })
                    variants.push({
                      variantSku: ele.variantSku,
                      variantData: ele.shopifyVariantData,
                      variantCode: ele.variantCode,
                      stock: ele.stock,
                      status: ele.status,
                      estimatedPurchasePrice: ele.estimatedPurchasePrice,
                      estimatedShipping: ele.estimatedShipping,
                      variantImages: ele.productSkuImages.map(x => x.url).join(","),
                      productVariantMarker: ele.productVariantMarker,
                      alias
                    })
                  })
                  if (isRequire) {
                    this.$message.error('请补充完整SKU别名再提交！')
                    return
                  }
                }
                const API = Baseurl + 'systemProduct/create'
                const paramsData = {
                  companyId: this.companyId,
                  salesType: this.form.salesType,
                  productImages: Imgs,
                  productImage: this.imgListSelect[0].data,
                  title: this.form.goodsName,
                  abbreviation: this.form.chineseName,
                  productCode: this.form.productId,
                  skuPrex: this.prefix,
                  categoryId: this.classification.id,
                  categoryName: this.classification.name,
                  sizeModel: this.form.model,
                  status: this.form.goodsState,
                  sourceUrl: sourceUrl,
                  stockNum: this.form.inventory,
                  productDescription: this.form.description,
                  remark: this.form.note,
                  roleId: this.roleId,
                  combinationProducts,
                  // relatedItems: this.relatedItems,
                  variants,
                  itemsBelonger: this.SKUAttributable
                }
                // return//请添加所捆绑产品的SKU别名
                this.createBtnLoading = true
                ajaxPost(API, paramsData)
                  .then((res) => {
                    if (res.data.code === 1) {
                      this.dialogVisible = false
                      this.$message.success('添加成功')
                      this.$emit('fatherMethod');
                      this.deleteId = []
                    } else {
                      this.$message.error(res.data.message)
                    }
                    this.createBtnLoading = false
                  }).catch(() => {
                    this.$alert('服务报错，请联系客服。', '提示', {
                      confirmButtonText: '确定'
                    });
                    this.createBtnLoading = false
                  })
              }
            }
          }
        } else {
          return false
        }
      })
    },
    addAttributable() {
      let obj = {
        status: 1,
        disabled: false
      }
      this.SKUAttributable.push(obj)
    },
    handleAssociated() {
      this.$refs.associated.init()
    },
    handleRadio(val) {
      this.type = 1
      this.aliasList = [{
        shopName: '',
        sellerType: '',
        shopId: '',
        productCodeAlias: '',
        ShopList: []
      }]
      this.result = false
      this.form = {
        salesType: val,
        goodsName: '',
        chineseName: '',
        productId: '',
        alias: '',
        model: '',
        goodsState: '1',
        supply: '',
        inventory: '0',
        description: '',
        note: '',
        associated: '',
        estimatedPurchasePrice: '',
        estimatedShipping: ''
      }
      this.productData = []
      this.imgList = []
      this.imageData = []
      this.SKUAttributable = []
      this.summarylist = []
      this.urlList = [{ id: 1, value: '' }]
      this.classification = {}
      this.classifications = []
      this.verifyDisabled = false
      this.checkedStore = {}
      this.imgListSelect = []
      this.variantText = ''
    },
    // 删除
    delet(key) {
      this.selectVariants[key] = []
      this.saveVariantInfoEdit()
    },
    // 获取变体 颜色和尺寸 组合的变体标识
    getvariantTag() {
      const listVariant = JSON.parse(JSON.stringify(this.selectVariants))
      const varinatData = []
      for (const item in listVariant) {
        if (listVariant[item].length) {
          varinatData.push(listVariant[item])
        }
      }
      if (!varinatData.length) return []
      return varinatData.reduce((a, b) =>
        a
          .map((aItem) => b.map((bItem) => `${aItem}&-;${bItem}`))
          .reduce((a, b) => [...a, ...b])
      )
    },
    saveVariantInfoEdit() {
      const variantTags = this.getvariantTag()
      // 根据组合好的变体标识生成表单数据
      const tableData = variantTags.map((item) => {
        let color = ''
        let size = ''
        let sleeve = ''
        let waist = ''
        if (this.selectVariants.颜色.length) {
          color = item.split('&-;')[0]
          size = item.split('&-;')[1]
          sleeve = item.split('&-;')[2]
          waist = item.split('&-;')[3]
        } else if (this.selectVariants.尺寸.length) {
          color = ''
          size = item.split('&-;')[0]
          sleeve = item.split('&-;')[1]
          waist = item.split('&-;')[2]
        } else if (this.selectVariants.袖长.length) {
          color = ''
          size = ''
          sleeve = item.split('&-;')[0]
          waist = item.split('&-;')[1]
        } else {
          color = ''
          size = ''
          sleeve = ''
          waist = item.split('&-;')[0]
        }
        const correctVariantTag = item.replace(new RegExp("&-;", ("gm")), "-")
        const tableItem = {
          color,
          size,
          sleeve,
          waist,
          productVariantMarker: correctVariantTag,
          productSkuImages: [],
          productCode: '',
          aliasDetailVO: [{ productCodeAlias: '' }],
          stock: 0,
          status: 1,
          estimatedPurchasePrice: '',
          estimatedShipping: ''
        }
        return tableItem
      })
      this.summarylist.forEach((item) => {
        tableData.forEach((key) => {
          const result1 = item.color === key.color
          if (result1) {
            key.productSkuImages = item.productSkuImages
            key.productCode = item.productCode
            key.stock = item.stock
            key.status = item.status
          }
        })
      })
      this.summarylistReset = tableData
      this.pushVariants()
      this.dialogVariantVisible = false
    },
    pushVariants() {
      if (!this.summarylist.length || !this.summarylistReset.length) {
        this.summarylist = JSON.parse(JSON.stringify(this.summarylistReset))
      } else {
        const arr = this.summarylistReset.map(x => x.productVariantMarker)
        const variants = []
        const indexs = []
        this.summarylist.map(item => {
          arr.map((ele, index) => {
            if (ele === item.productVariantMarker) {
              variants.push(item)
              indexs.push(index)
            }
          })
        })
        this.summarylistReset.map((item, index) => {
          if (!indexs.includes(index)) {
            variants.push(item)
          }
        })
        this.summarylist = variants
      }
    },
    CheckArrayElement(arrData) {
      // arrData.sort() //数组排序
      var reNum = '' //返回结果
      //遍历整个数组对象
      for (var i = 0; i < arrData.length; i++) {
        //跳过最后一个元素的比较
        if (i + 1 == arrData.length) {
          continue
        }
        //判断相邻的元素是否相同
        if (arrData[i] == arrData[i + 1]) {
          reNum = arrData[i]
        }
      }
      return reNum
    },
    saveVariantInfoEdit1() {
      if (!this.variantText) return
      const arrData = this.variantText
        .replace(/，/g, ',')
        .split(',')
        .filter((item) => !!item)

      if (this.CheckArrayElement(arrData) != '') {
        this.$message.error(
          this.CheckArrayElement(arrData) +
          '此项已选择，每项只可选择一次！'
        )
        return
      }
      this.selectVariants[this.specsIndex] = arrData
      this.saveVariantInfoEdit()
    },
    addSizeColor(value, key) {
      this.dialogVariantVisible = true
      this.specsIndex = key
      this.variantText = value.join(',')
      if (this.specsIndex === '尺寸') {
        this.recommendSpecs = sizeList.sizeList
      } else if (this.specsIndex === '颜色') {
        this.recommendSpecs = colorList.colorList
      } else if (this.specsIndex === '袖长') {
        this.recommendSpecs = sleeveList.sleeveList
      } else {
        this.recommendSpecs = waistSize.waistSize
      }
    },
    getVariantSelect(val) {
      this.variantText = ''
      // 反显之前的选择的颜色或尺寸
      this.variantText =
        this.selectVariants[this.specsIndex] &&
        this.selectVariants[this.specsIndex].join(',')
      if (val === '尺寸') {
        this.recommendSpecs = sizeList.sizeList
      } else if (val === '颜色') {
        this.recommendSpecs = colorList.colorList
      } else if (val === '袖长') {
        this.recommendSpecs = sleeveList.sleeveList
      } else {
        this.recommendSpecs = waistSize.waistSize
      }
    },
    // 选择颜色和尺寸
    putText(item) {
      let en_value = item.split('-')[1] ? item.split('-')[1].trim() : item
      let variantTextArray = []
      if (this.variantText) {
        variantTextArray = this.variantText.split(',')
      }
      if (variantTextArray.some((item) => item === en_value)) {
        this.$message.error('已选择此项')
        return false
      }
      variantTextArray.push(en_value)
      this.variantText = variantTextArray.join(',')
    },
    addVariant() {
      this.dialogVariantVisible = true
    },
    complete(index) {
      this.type = index
    },
    edit_blue_point() {
      this.aliasList.push({
        shopName: '',
        sellerType: '',
        productCodeAlias: '',
        ShopList: []
      })
      this.verifyDisabled = false
    },
    edit_blue_del(index) {
      this.aliasList.splice(index, 1)
    },
    edit_blue_point1() {
      this.urlList.push({
        id: this.urlList.length + 1,
        value: ''
      })
    },
    edit_blue_del1(index) {
      this.urlList.splice(index, 1)
    },
    handleAvatarSuccess(file, fileList) {
      file = Object.assign(file, {
        'url': file.data
      })
      this.imageData.push(file)
      this.imgList = this.imageData
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.ImageVisible = true;
    },
    //删除要上传的图片
    handleRemove(_, fileList) {
      this.imgList = fileList
      // this.imgList = this.imageData
    },
    beforeClose() {
      this.$confirm('关闭弹窗将无法保存相关数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleRadio('1')
        this.dialogVisible = false
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消关闭'
        });
      });
    },
    setShop() {
      let strArr = this.inputArray
      let arr = JSON.parse(JSON.stringify(this.summarylist[0].aliasDetailVO))
      arr.map(item => {
        item.productCodeAlias = ''
      })
      this.summarylist.map((item, index) => {
        if (index != 0) {
          item.aliasDetailVO = JSON.parse(JSON.stringify(arr))
        }
        if(strArr.length > 0) {
          const i = 0; // Replace this with your logic to determine the index
          item.aliasDetailVO[i].productCodeAlias = strArr[index];
        }
        
      })
    },
    setPrice(type) {
      if (type == 1) {
        let estimatedPurchasePrice = JSON.parse(JSON.stringify(this.summarylist[0].estimatedPurchasePrice))
        this.summarylist.map((item, index) => {
          if (index != 0) {
            item.estimatedPurchasePrice = estimatedPurchasePrice
          }
        })
      } else {
        let estimatedShipping = JSON.parse(JSON.stringify(this.summarylist[0].estimatedShipping))
        this.summarylist.map((item, index) => {
          if (index != 0) {
            item.estimatedShipping = estimatedShipping
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.xingwarp {
  position: relative;
  .xingxing {
    color: #F56C6C;
    position: absolute;
    left: -92px;
    top: 0;
  }
}
.morePlatform /deep/ .el-select {
  width: 100%;
}

.el-input {
  width: 430px;
}

.Minister-top-top {
  width: 100%;
  height: 30px;
  margin-bottom: 20px;
  border-radius: 3px;

  .Minister-top-left {
    border-radius: 3px 0 0 3px;
    width: 80px;
    line-height: 30px;
    float: left;
    text-align: center;
    font-size: 16px;
    color: #fff;
  }

  .Minister-top-color {
    background: #39b54a;
  }

  .product-top-color {
    background: #f37b1d;
  }

  .information-top-color {
    background: #0081ff;
  }

  .Minister-top-right {
    width: 80px;
    line-height: 40px;
    float: right;
    font-size: 16px;
    text-align: center;
  }
}

.informationbackground {
  background: #bfe2f3;
}

.productbackground {
  background: #fde6d2;
}

.Ministerbackground {
  background: #d7f0dbff;
}

.summary_complete_bag {
  overflow: hidden;

  .summary_complete {
    overflow: hidden;
    margin-bottom: 20px;
    border-bottom: 1px #eee solid;

    div {
      padding: 0 10px;
      height: 30px;
      line-height: 30px;
      border: #2c8dff 1px solid;
      text-align: center;
      float: left;
      cursor: pointer;
    }

    .active {
      background: #2c8dff;
      color: #fff;
    }
  }
}

.rs-tab {
  width: 853px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  margin-top: 10px;
  padding: 10px 0;
  line-height: 25px;
}

.rs-tab li {
  display: inline-block;
}

.select-img {
  width: 100%;
  height: 320px;
  overflow: auto;

  .option {
    width: 148px;
    height: 148px;
    margin: 0 8px 8px 0;
    float: left;
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    position: relative;

    .img-mask {
      position: absolute;
      right: -17px;
      top: -7px;
      width: 46px;
      height: 26px;
      background: #13ce66;
      text-align: center;
      transform: rotate(45deg);

      .el-true-check {
        color: #fff;
        font-size: 12px;
        margin-top: 12px;
        transform: rotate(-45deg);
      }
    }

    img {
      width: 146px;
    }
  }
}

.custom-update {
  /deep/ .el-upload--picture-card {
    background: initial;
    border: initial;
    width: initial;
    height: initial;
    line-height: initial;
  }
}

.image-container {
  display: flex;
  flex-wrap: wrap;

  .img-box {
    width: 178px;
    height: 178px;
    margin-right: 10px;
    margin-bottom: 10px;
    border: 1px solid #eee;
    border-radius: 6px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.checked-img-container {
  width: 100%;
  height: 36px;
  display: flex;
  align-items: flex-end;
  margin-bottom: 5px;

  .img-box {
    width: 28px;
    height: 28px;
    border-radius: 4px;
    position: relative;
    margin-right: 10px;
    line-height: 28px;

    img {
      width: 100%;
      height: 100%;
      border: 1px solid #dcdfe6;
    }

    .el-icon-circle-close {
      display: none;
      position: absolute;
      right: -7px;
      top: -7px;
      color: #999;
      font-size: 14px;
      font-weight: 700;
      cursor: pointer;
    }

    &:hover .el-icon-circle-close {
      display: block;
    }
  }
}

.list-group {
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  .list-group-item {
    width: 178px;
    height: 178px;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
    // float: left;
    position: relative;
    overflow: hidden;
    .mask {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.5);
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      transition-duration: 0.5s;
      .custom-icon {
        font-size: 20px;
        margin: 0 8px;
        color: #fff;
      }
    }
    &:hover .mask {
      opacity: 1;
      border-color: #409eff;
    }
  }
  .list-group-item img {
    width: 100%;
    height: 100%;
  }
}
</style>

<style lang="scss" scoped>
.uploadPictures {
  /deep/ .el-upload-list__item {
    width: 178px;
    height: 178px;
  }
  /deep/ .el-upload--picture-card {
    width: 178px;
    height: 178px;
    line-height: 178px;
    padding: 0 20px;
  }
  /deep/ .selectUpload {
    // .el-upload.el-upload--picture-card,
    .el-upload-list__item-status-label {
      display: none;
    }
  }
  /deep/ .upload-demo {
    .el-upload-list--picture-card.el-upload-list {
      display: none;
    }
    .el-upload--picture-card {
      line-height: initial;

      .el-upload-dragger {
        width: 100%;
        height: 100%;
        border: none;
      }
    }
  }
  /deep/ .el-dialog__body {
    word-break: break-word;
  }
  .flip-list-move {
    transition: transform 0.5s;
  }
  .no-move {
    transition: transform 0s;
  }
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }
  .list-group {
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    .list-group-item {
      width: 178px;
      height: 178px;
      background-color: #fbfdff;
      border: 1px dashed #c0ccda;
      border-radius: 6px;
      box-sizing: border-box;
      cursor: pointer;
      margin-right: 10px;
      margin-bottom: 10px;
      // float: left;
      position: relative;
      overflow: hidden;
      .mask {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        transition-duration: 0.5s;
        .custom-icon {
          font-size: 20px;
          margin: 0 8px;
          color: #fff;
        }
      }
      &:hover .mask {
        opacity: 1;
        border-color: #409eff;
      }
    }
    .list-group-item img {
      width: 100%;
      height: 100%;
    }
  }
  .showImg {
    width: 148px;
    float: left;
    margin-right: 15px;
  }
  .avatar-uploader {
    width: 178px;
    height: 178px;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    text-align: center;
    line-height: 178px;
    font-size: 40px;
    &:hover {
      border-color: #409eff;
    }
  }
}
</style>